var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 8.414L7.99994 2.414L1.99994 8.414L0.585938 7L7.29294 0.293C7.48047 0.105529 7.73477 0.000213623 7.99994 0.000213623C8.2651 0.000213623 8.51941 0.105529 8.70694 0.293L15.4139 7L13.9999 8.414Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 14.414L7.99994 8.414L1.99994 14.414L0.585938 13L7.29294 6.293C7.48047 6.10553 7.73477 6.00021 7.99994 6.00021C8.2651 6.00021 8.51941 6.10553 8.70694 6.293L15.4139 13L13.9999 14.414Z",
    fill: "#8E8E8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatus);
export default __webpack_public_path__ + "static/media/icon_status.6e75d1ea.svg";
export { ForwardRef as ReactComponent };